import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';

function label(name) {
  return i18n(`entities.newsletter.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.newsletter.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true
  }),
  lastname: new StringField('lastname', label('lastname'), {
    "required": true
  }),
  email: new StringField('email', label('email'), {
    "required": true
  }),
  zipcode: new StringField('zipcode', label('zipcode'), {
    "required": true
  }),
  state: new EnumeratorField('state', label('state'), [
    { id: 'New_York', label: enumeratorLabel('state', 'New_York') },
    { id: 'Alabama', label: enumeratorLabel('state', 'Alabama') },
    { id: 'Alaska', label: enumeratorLabel('state', 'Alaska') },
    { id: 'American_Samoa', label: enumeratorLabel('state', 'American_Samoa') },
    { id: 'Arizona', label: enumeratorLabel('state', 'Arizona') },
    { id: 'Arkansas', label: enumeratorLabel('state', 'Arkansas') },
    { id: 'California', label: enumeratorLabel('state', 'California') },
    { id: 'Colorado', label: enumeratorLabel('state', 'Colorado') },
    { id: 'Connecticut', label: enumeratorLabel('state', 'Connecticut') },
    { id: 'Delaware', label: enumeratorLabel('state', 'Delaware') },
    { id: 'District_Of_Columbia', label: enumeratorLabel('state', 'District_Of_Columbia') },
    { id: 'Federated_States_Of_Micronesia', label: enumeratorLabel('state', 'Federated_States_Of_Micronesia') },
    { id: 'Florida', label: enumeratorLabel('state', 'Florida') },
    { id: 'Georgia', label: enumeratorLabel('state', 'Georgia') },
    { id: 'Guam', label: enumeratorLabel('state', 'Guam') },
    { id: 'Hawaii', label: enumeratorLabel('state', 'Hawaii') },
    { id: 'Idaho', label: enumeratorLabel('state', 'Idaho') },
    { id: 'Illinois', label: enumeratorLabel('state', 'Illinois') },
    { id: 'Indiana', label: enumeratorLabel('state', 'Indiana') },
    { id: 'Iowa', label: enumeratorLabel('state', 'Iowa') },
    { id: 'Kansas', label: enumeratorLabel('state', 'Kansas') },
    { id: 'Kentucky', label: enumeratorLabel('state', 'Kentucky') },
    { id: 'Louisiana', label: enumeratorLabel('state', 'Louisiana') },
    { id: 'Maine', label: enumeratorLabel('state', 'Maine') },
    { id: 'Marshall_Islands', label: enumeratorLabel('state', 'Marshall_Islands') },
    { id: 'Maryland', label: enumeratorLabel('state', 'Maryland') },
    { id: 'Massachusetts', label: enumeratorLabel('state', 'Massachusetts') },
    { id: 'Michigan', label: enumeratorLabel('state', 'Michigan') },
    { id: 'Minnesota', label: enumeratorLabel('state', 'Minnesota') },
    { id: 'Mississippi', label: enumeratorLabel('state', 'Mississippi') },
    { id: 'Missouri', label: enumeratorLabel('state', 'Missouri') },
    { id: 'Montana', label: enumeratorLabel('state', 'Montana') },
    { id: 'Nebraska', label: enumeratorLabel('state', 'Nebraska') },
    { id: 'Nevada', label: enumeratorLabel('state', 'Nevada') },
    { id: 'New_Hampshire', label: enumeratorLabel('state', 'New_Hampshire') },
    { id: 'New_Jersey', label: enumeratorLabel('state', 'New_Jersey') },
    { id: 'New_Mexico', label: enumeratorLabel('state', 'New_Mexico') },
    { id: 'New_York', label: enumeratorLabel('state', 'New_York') },
    { id: 'North_Carolina', label: enumeratorLabel('state', 'North_Carolina') },
    { id: 'North_Dakota', label: enumeratorLabel('state', 'North_Dakota') },
    { id: 'Northern_Mariana_Islands', label: enumeratorLabel('state', 'Northern_Mariana_Islands') },
    { id: 'Ohio', label: enumeratorLabel('state', 'Ohio') },
    { id: 'Oklahoma', label: enumeratorLabel('state', 'Oklahoma') },
    { id: 'Oregon', label: enumeratorLabel('state', 'Oregon') },
    { id: 'Palau', label: enumeratorLabel('state', 'Palau') },
    { id: 'Pennsylvania', label: enumeratorLabel('state', 'Pennsylvania') },
    { id: 'Puerto_Rico', label: enumeratorLabel('state', 'Puerto_Rico') },
    { id: 'Rhode_Island', label: enumeratorLabel('state', 'Rhode_Island') },
    { id: 'South_Carolina', label: enumeratorLabel('state', 'South_Carolina') },
    { id: 'South_Dakota', label: enumeratorLabel('state', 'South_Dakota') },
    { id: 'Tennessee', label: enumeratorLabel('state', 'Tennessee') },
    { id: 'Texas', label: enumeratorLabel('state', 'Texas') },
    { id: 'Utah', label: enumeratorLabel('state', 'Utah') },
    { id: 'Vermont', label: enumeratorLabel('state', 'Vermont') },
    { id: 'Virgin_Islands', label: enumeratorLabel('state', 'Virgin_Islands') },
    { id: 'Virginia', label: enumeratorLabel('state', 'Virginia') },
    { id: 'Washington', label: enumeratorLabel('state', 'Washington') },
    { id: 'West_Virginia', label: enumeratorLabel('state', 'West_Virginia') },
    { id: 'Wisconsin', label: enumeratorLabel('state', 'Wisconsin') },
    { id: 'Wyoming', label: enumeratorLabel('state', 'Wyoming') },
  ],{
    "required": true
  }),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class NewsletterModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
